var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.5 5.78033C1.5 5.44077 1.63489 5.11511 1.875 4.875C2.11511 4.63489 2.44077 4.5 2.78033 4.5H21.2197C21.5592 4.5 21.8849 4.63489 22.125 4.875C22.3651 5.11511 22.5 5.44077 22.5 5.78033V18.2197C22.5 18.5592 22.3651 18.8849 22.125 19.125C21.8849 19.3651 21.5592 19.5 21.2197 19.5H2.78033C2.44077 19.5 2.11511 19.3651 1.875 19.125C1.63489 18.8849 1.5 18.5592 1.5 18.2197V5.78033ZM3 6.8025V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V6.804L12.8282 13.0714C12.5927 13.2521 12.3041 13.35 12.0072 13.35C11.7107 13.35 11.4224 13.2523 11.187 13.072L3 6.8025ZM19.545 6H4.455L12 11.8035L19.545 6Z","fill":"currentColor"}));
}

Mail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
